import React, { useState } from "react";

const AlertBox = ({ message, variant = "danger" }) => {
  const [show, setShow] = useState(true);

  return (
    show && (
      <div className={`alert alert-${variant}  show`} role="alert">
         <div dangerouslySetInnerHTML={{ __html: message }} />
        <span 
          title="Click to dismiss alert box" 
          style={{ float: "right", cursor: "pointer",fontWeight:"bold",position:"relative",bottom:"19px" }}
          className="btn-close"
          onClick={() => setShow(false)}
          aria-label="Close"
        >X</span>
      </div>
    )
  );
};

export default AlertBox;
